import { SupplementaryMaterialsPanel } from 'components/supplementary_materials/SupplementaryMaterialsPanel';
import { useCallback } from 'react';
import { useUpdate } from '@refinedev/core';

interface InstitutionalMaterialsRecord {
  id: string;
  code?: string;
  media?: { institutional_materials?: boolean };
}

interface TabInstitutionalMaterialsProps {
  parentKind: 'course' | 'graduate_course';
  record: InstitutionalMaterialsRecord;
}

const RESOURCE_BY_KIND = {
  course: 'courses',
  graduate_course: 'graduate_courses'
} as const;

export const TabInstitutionalMaterials = ({
  parentKind,
  record
}: TabInstitutionalMaterialsProps) => {
  const { id: parentReference, code, media } = record;
  const published = Boolean(media?.institutional_materials);
  const { mutate: updateCourse, isLoading } = useUpdate();

  const setPublished = useCallback(
    (value: boolean) => {
      updateCourse({
        resource: RESOURCE_BY_KIND[parentKind],
        id: parentReference,
        values: {
          // A API exige o code ao atualizar um curso de graduação que já o possui.
          ...(code ? { code } : {}),
          media: { institutional_materials: value }
        },
        successNotification: () => ({
          type: 'success',
          description: 'Tudo certo!',
          message: value
            ? 'Materiais institucionais publicados para os alunos!'
            : 'Materiais institucionais despublicados!'
        }),
        errorNotification: () => ({
          type: 'error',
          description: 'Algo deu errado!',
          message: value
            ? 'Não foi possível publicar os materiais institucionais.'
            : 'Não foi possível despublicar os materiais institucionais.'
        })
      });
    },
    [code, parentKind, parentReference, updateCourse]
  );

  return (
    <SupplementaryMaterialsPanel
      parentKind={parentKind}
      parentReference={parentReference}
      variant="institutional"
      publication={{
        published,
        isLoading,
        onPublish: () => setPublished(true),
        onUnpublish: () => setPublished(false)
      }}
    />
  );
};
